import './SectionWithRotatingCallipers.scss';

class SectionWithRotatingCallipers {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['SectionWithRotatingCallipers'] = SectionWithRotatingCallipers;
export default SectionWithRotatingCallipers;
